export const IMAGE_FILE_TYPES = [
  'jpeg',
  'jpg',
  'png',
  'svg',
  'webp',
  'gif',
  'jfif',
  'pjpeg',
  'pjp',
  'apng',
  'avif',
  'tif',
  'tiff',
  'heif',
  'bmp',
  'eps',
  'raw',
  'cr2',
  'nef',
  'orf',
  'sr2',
  'psd',
  'heic',
  'dib',
  'ai',
];

export const VIDEO_FILE_TYPES = [
  'mp4',
  'webm',
  'mkv',
  'flv',
  'vob',
  'ogv',
  'ogg',
  'drc',
  'gif',
  'gifv',
  'mng',
  'avi',
  'mov',
  'qt',
  'mts',
  'm2ts',
  'ts',
  'wmv',
  'yuv',
  'rm',
  'rmvb',
  'viv',
  'asf',
  'amv',
  'm4p',
  'mpeg',
  'mpe',
  'm2v',
  'm4v',
  'svi',
  '3gp',
  '3g2',
  'mxf',
  'roq',
  'nsv',
  'f4v',
  'f4p',
  'f4a',
  'f4b',
];
